import {useRef, useState} from 'react';
import {NavLink, Outlet, useNavigate} from 'react-router';

import Button from 'components/Button';
import KyError from 'components/Errors/KyError';
import Loading from 'components/Loading';
import useAppContext from 'conf/AppContext';
import {useAuth} from 'context/AuthContext';
import {useTheme} from 'context/ThemeContext';

import './index.scss';


export default function Navbar() {
  const appContext = useAppContext();
  const collapseRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const {isAuthenticated, setIsAuthenticated, loading} = useAuth();
  const {theme, toggleTheme} = useTheme();

  const handleNavClick = () => {
    if (collapseRef.current && collapseRef.current.classList.contains('show')) {
      const bsCollapse = window.bootstrap.Collapse.getInstance(collapseRef.current);
      bsCollapse.hide();
      setIsOpen(false);
    }
  };

  const toggleNavbar = () => {
    setIsOpen((prev) => !prev);
  };

  const handleLogout = async () => {
    try {
      await appContext.api.post('api/v1/users/logout');
      localStorage.removeItem('login');
      setIsAuthenticated(false);
      handleNavClick();
      navigate('/');
    } catch (err) {
      if (err?.response?.status === 401) {
        localStorage.clear();
        navigate('/');
      }
      setError(err);
    }
  };

  const handleToggles = () => {
    toggleTheme();
    handleNavClick();
  };

  if (loading) {
    return <Loading />;
  }
  
  if (error) {
    return <KyError kyError={error} />;
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg headerPage bg-black">
        <div className="container">
          <NavLink to="/" end={true} className="navbar-brand fs-custom text-white" onClick={handleNavClick}>
            Fuzzy Score{' '}
            <i className="bi bi-rocket-takeoff" />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={toggleNavbar}
          >
            <i className={`bi ${isOpen ? 'bi-x-lg' : 'bi-list'} fs-1 navbar-toggler-icon-custom`} />
          </button>
          <div className="collapse navbar-collapse justify-content-end mt-1" id="navbarNav" ref={collapseRef}>
            <ul className="navbar-nav text-center text-lg-start">
              <li className="nav-item me-1">
                <NavLink to="/github" end={true} className="nav-link" onClick={handleNavClick}>
                  <span>GitHub</span>
                </NavLink>
              </li>
              <li className="nav-item me-1">
                <NavLink to="/companyTechStack" end={true} className="nav-link" onClick={handleNavClick}>
                  <span>Companies</span>
                </NavLink>
              </li>
              <li className="nav-item me-1">
                <NavLink to="/ninjas" end={true} className="nav-link" onClick={handleNavClick}>
                  <span>Ninjas</span>
                </NavLink>
              </li>
              <li className="nav-item me-1">
                <NavLink to="/stats" end={true} className="nav-link" onClick={handleNavClick}>
                  <span>Stats</span>
                </NavLink>
              </li>
              {isAuthenticated && (
                <li className="nav-item me-1">
                  <NavLink to="/dashboard" end={true} className="nav-link" onClick={handleNavClick}>
                    <span>Dashboard</span>
                  </NavLink>
                </li>
              )}
              <li className="nav-item d-lg-inline-flex align-items-center">
                <button
                  onClick={handleToggles}
                  className="btn"
                  title={`Switch to ${theme === 'dark' ? 'Light' : 'Dark'} Mode`}
                >
                  {theme === 'dark' ? (
                    <i className="bi bi-moon-stars-fill theme-icon text-primary" />
                  ) : (
                    <i className="bi bi-sun-fill theme-icon text-warning" />
                  )}
                </button>
              </li>
            </ul>

            {!isAuthenticated ? (
              <>
                <NavLink to="/register" end={true} className="nav-link text-center" onClick={handleNavClick}>
                  <button className="btn btn-dark btn-lg me-md-2" type="submit">Sign Up</button>
                </NavLink>
                <NavLink to="/login" end={true} className="nav-link text-center" onClick={handleNavClick}>
                  <button className="btn btn-secondary btn-lg" type="submit">Login</button>
                </NavLink>
              </>
            ) : (
              <div className="nav-link text-center">
                <Button actionHandler={handleLogout} className="btn btn-secondary btn-lg" type="submit">Logout</Button>
              </div>
            )}
          </div>
        </div>
      </nav>
      <Outlet />
    </>
  );
}
